import { StoreSchema } from '../../../shared/config/storeConfig/StoreSchema'

export const selectError = (store: StoreSchema) => store.authUser.error